import { createStore, applyMiddleware, compose} from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore } from "redux-persist";
import reducer from "../reducers/index";
import mySaga from "../Sagas/sagas";

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// mount it on the Store
// 4-09-2019 by rn
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    reducer,
    composeEnhancer(applyMiddleware(sagaMiddleware)),
);
// const store = createStore(
//   reducer,
//   compose(window.devToolsExtension ? window.devToolsExtension() : f => f),
//   applyMiddleware(sagaMiddleware)
// );
// 4-09-2019 by rn

// const store = createStore(reducer, applyMiddleware(sagaMiddleware));

const persistor = persistStore(store);

// then run the saga
sagaMiddleware.run(mySaga);

export { store, persistor };
